<template>
  <div class="dashboard noverflow">
    <div class="row mb-3">
      <div class="col-8">
        <h2 class="bold"><span class="middle">Dashboard</span> <span class="btnContainer bg-blue">
          <button type="button" :class="(filtre=='carte'?'active':'')" @click="filter_data('carte')"><span class="material-icons">map</span></button>
          <button type="button" :class="(filtre=='fiche'?'active':'')" @click="filter_data('fiche')"><span class="material-icons">donut_large</span></button>
        </span></h2>
      </div>
      <div class="col-4 text-right">
          <b-link class="btn btn-secondary mr-2" href="javascript:void(0)" @click="exportD()"><span v-if="!exportProgress" class="material-icons" style="font-size: 20px;margin-bottom: -5px;position: relative;top: 2px;">file_download</span><span v-else>{{ $i18n.t("Export en cours") }} ...</span></b-link>
          <b-link class="btn btn-outline-secondary" href="javascript:void(0)" @click="showFilter=!showFilter"><span v-if="!showFilter">{{ $i18n.t("Filtrer les résultats") }}</span><span v-else>{{ $i18n.t("Fermer les filtres") }}</span></b-link>
      </div>
    </div>
    <div class="fiche" v-if="filtre=='fiche' && fiche.biens_evalues">
      <div class="bg-blue evalBlock bigText row mt-3">
        <div class="col-md-6">
          <h1 class="bold">{{$t("Votre portefeuille immobilier")}}</h1>
        </div>
        <div class="col-md-6 text-right">
          <span v-if="fiche.indice_confiance !== null"><Gauge :value="fiche.indice_confiance"/></span><span v-else class="small">{{nodata}}</span>
        </div>
        <div class="col-4 statB bb br">
          <b>{{$t("Biens évalués")}}</b>
          <h2><span v-if="parseFloat(fiche.biens_evalues)!=0">{{ format_number(fiche.biens_evalues) }}</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB bb br">
          <b>{{$t("Evaluations Ooftop")}}</b>
          <h2><span v-if="parseFloat(fiche.eval)!=0">{{ format_number(fiche.eval) }}</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB bb">
          <b>{{$t("Valorisation")}}</b>
          <h2><span v-if="parseFloat(fiche.valorisation)!=0">{{ format_number(fiche.valorisation) }} €</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB bb br">
          <b>{{$t("Prix moyen")}}</b>
          <h2><span v-if="parseFloat(fiche.estimation)!=0">{{ format_number(fiche.estimation) }} {{$t("€")}}</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB bb br">
          <b>{{$t("Prix moyen au m²")}}</b>
          <h2><span v-if="parseFloat(fiche.estimation_m2)!=0">{{ format_number(fiche.estimation_m2) }} {{$t("€")}}/m²</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB bb">
          <b>{{$t("Superficie moyenne")}}</b>
          <h2><span v-if="parseFloat(fiche.superficie)!=0">{{ format_number(fiche.superficie) }} m²</span><span v-else class="small">{{nodata}}</span></h2>
        </div>
        <div class="col-4 statB br" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_EXIM')).length">
          <b>{{$t("Expertises immobilières")}}</b>
          <h2><span v-if="parseFloat(fiche.exim)!=0">{{ format_number(fiche.exim) }}</span><span v-else class="small">0</span></h2>
        </div>
        <div class="col-4 statB br" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_AVAL')).length">
          <b>{{$t("Avis de valeur")}}</b>
          <h2><span v-if="parseFloat(fiche.aval)!=0">{{ format_number(fiche.aval) }}</span><span v-else class="small">0</span></h2>
        </div>
        <div class="col-4 statB br" v-if="infos_cli && infos_cli.menu && infos_cli.menu.filter(p=>(p.id=='menu_DOCL')).length">
          <b>{{$t("Documents légaux")}}</b>
          <h2><span v-if="parseFloat(fiche.docl)!=0">{{ format_number(fiche.docl) }}</span><span v-else class="small">0</span></h2>
        </div>
      </div>
      <div class="row mt-4 charts">
        <div class="col-6 mb-3" v-for="(graph,gi) in fiche.graphs" :key="gi">
          <div class="bg-blue">
            <h3 class="bold">{{graph.title}}</h3>
            <chart width="100%" height="50" :id="gi" type="doughnut" :title="graph.title" :labels='graph.labels' :data='graph.datas'></chart>
          </div>
        </div>
      </div>
    </div>
    <div :class="'carte '+(this.filtre=='carte'?'':'hide')">
      <div class="row">
        <div class="col-3">
          <ul v-if="Object.keys(mapList).length">
            <li v-for="(ml,mlid) in mapList" :key="'mapL_'+mlid" :data-id="ml.id" :data-lat="ml.lat" :data-lng="ml.lng" :data-path="('/'+ml.pf+'/detail/'+ml.id)">
              <h4 class="bold uppercase"><span class="round">{{parseInt(mlid)+1}}</span> {{ml.ville}} ({{ml.reference}})</h4>
              <div class="row">
                <div class="col-6">
                  <p><span class="material-icons">home</span> {{$t(ml.type_de_bien)}}</p>
                  <p><span class="material-icons">fullscreen</span> {{ml.superficie}} m²</p>
                </div>
                <div class="col-6">
                  <p><span class="material-icons">sell</span> <span class="hight bold">{{$t("$")}} {{format_number(ml.estimation)}} {{$t("€")}}</span></p>
                  <p><span class="material-icons">today</span> {{ml.date.split(' ')[0]}}</p>
                </div>
              </div>
            </li>
          </ul>
          <p style="position:absolute;top:-6px;left:16px" v-if="!loading"><small>{{ Object.keys(mapList).length}} {{" résultat"+(Object.keys(mapList).length>1?"s":"") }}</small></p>
        </div>
        <div class="col-9" id="mapContainer">
          <div id="map" class="map"></div>
        </div>
      </div>
    </div>
    <div :class="'filters searchFilter  '+((this.showFilter)?'':'hide')">
      <h2 class="bold mb-3">{{$t("Filtres de recherche")}}</h2>
      <a href="javascript:void(0)" @click="showFilter=false" class="close"><span class="material-icons">close</span></a>
      <h4 class="mb-3">{{$t("Zone géographique")}}</h4>
      <b-form-group label-for="recherche">
        <b-form-input id="recherche" v-model='forms.recherche' maxlength="50" :placeholder="$t('Ville, département')+' ...'"></b-form-input>
      </b-form-group>
      <h4 class="mb-3 mt-3">{{$t("Prestations")}}</h4>
      <b-form-group id="prestations" label-for="prestations">
        <multiselect :showNoOptions="false"  :showNoResults="false" v-model="forms.prestations" :options="options_prestations" :placeholder="$t('Sélectionnez une ou plusieurs prestation(s)')" label="text" track-by="text" :multiple="true"  :selectLabel="$t('Entrer pour valider')" :selectedLabel="$t('Ajouté')"  :close-on-select="false" :clear-on-select="false"></multiselect>
      </b-form-group>
      <h4 class="mb-3 mt-3">{{$t("Type de bien")}}</h4>
      <multiselect :showNoOptions="false"  :showNoResults="false" v-model="forms.types_bien" :options="options_types_bien" :placeholder="$t('Sélectionnez un ou plusieurs type(s)')" label="text" track-by="text" :multiple="true"  :selectLabel="$t('Entrer pour valider')" :selectedLabel="$t('Ajouté')"  :close-on-select="false" :clear-on-select="false"></multiselect>
      <h4 class="mb-3 mt-3">{{$t("Période personnalisée")}}</h4>
      <div class="row">
        <div class="col-md-6">
          <b-input-group class="mb-3">
            <b-form-input id="forms-debut" v-model="forms.periode.debut" type="text" :placeholder="$t('Date de début')" autocomplete="off" v-mask="$t('####-##-##')"></b-form-input>
            <b-input-group-append>
              <b-form-datepicker v-model="forms.periode.debut_dp" button-only right :locale="$t('fr-FR')" aria-controls="forms-debut" @context="onContextDate('debut')" :labelNoDateSelected="$t('Aucune date sélectionnée')"></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div class="col-md-6">
          <b-input-group class="mb-3">
            <b-form-input id="forms-fin" v-model="forms.periode.fin" type="text" :placeholder="$t('Date de fin')" autocomplete="off" v-mask="$t('####-##-##')"></b-form-input>
            <b-input-group-append>
              <b-form-datepicker v-model="forms.periode.fin_dp" button-only right :locale="$t('fr-FR')" aria-controls="forms-fin" @context="onContextDate('fin')" :labelNoDateSelected="$t('Aucune date sélectionnée')"></b-form-datepicker>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="sliderRange">
        <h4 class="mb-3">{{$t("Prix")}}</h4>
        <div id="prix"></div>
        <p class="spanAbso mt-1">
          <span>
            <span v-if="!prixMinFocus" @click="prixMinFocus=1;forms.prix[0]=forms.prix[0].replace('.00','')">{{ format_number(forms.prix[0]) }}</span>
            <b-form-input v-else @blur="prixMinFocus=0;reset_nui();" type="number" v-model.number="forms.prix[0]" :min="datas_def.estimation_min" :max="forms.prix[1]" step="5" @keypress="isNumber($event)"></b-form-input>
              {{$t("€")}}
          </span>
          <span>
            <span v-if="prixMaxFocus!=1" @click="prixMaxFocus=1;forms.prix[1]=forms.prix[1].replace('.00','')">{{ format_number(forms.prix[1]) }}</span>
            <b-form-input v-else @blur="prixMaxFocus=0;reset_nui();" type="number" v-model.number="forms.prix[1]" :min="forms.prix[0]" :max="datas_def.estimation_max" step="5" @keypress="isNumber($event)"></b-form-input>
              {{$t("€")}}
          </span>
        </p>
        <h4 class="mt-5 mb-3">{{$t("Surface")}}</h4>
        <div id="surface"></div>
        <p class="spanAbso mt-1">
          <span>
            <span v-if="!surfaceMinFocus" @click="surfaceMinFocus=1;forms.surface[0]=forms.surface[0].replace('.00','')">{{ format_number(forms.surface[0]) }}</span>
            <b-form-input v-else @blur="surfaceMinFocus=0;reset_nui();" type="number" v-model.number="forms.surface[0]" min="0" :max="forms.surface[1]" step="5" @keypress="isNumber($event)"></b-form-input>
              {{$t("m²")}}
          </span>
          <span>
            <span v-if="surfaceMaxFocus!=1" @click="surfaceMaxFocus=1;forms.surface[0]=forms.surface[1].replace('.00','')">{{ format_number(forms.surface[1]) }}</span>
            <b-form-input v-else @blur="surfaceMaxFocus=0;reset_nui();" type="number" v-model.number="forms.surface[1]" :min="forms.surface[0]" :max="datas_def.surface_max" step="5" @keypress="isNumber($event)"></b-form-input>
              {{$t("m²")}}
          </span>
        </p>
      </div>
      <p>
        <b-button class="btn-gold" style="display:block;margin-top:100px;width:100%;" type="button" @click="refresh" :disabled="loading">
          <span v-if="loading">{{$t("Actualisation")}} ...</span>
          <span v-if="!loading">{{$t("Actualiser les résultats")}}</span>
        </b-button>
        <button type="button" class="btn btn-primary btn-text btn-sm text-center" @click="reset_data">{{$t("Réinitialiser")}}</button>
      </p>
    </div>
  </div>
</template>

<script>
  import axios from "axios";
  import multiselect from 'vue-multiselect'
  import noUiSlider from 'nouislider';
  import 'nouislider/distribute/nouislider.css';
  import Chart from "@/components/Chart";
  import Gauge from '@/components/Gauge'
  export default {
    name: "dashboard",
    components: {
      Chart,
      Gauge,
      multiselect
    },
    data () {
      return {
        loading:false,
        filtre:'carte',
        nodata:this.$i18n.t('Données insuffisantes'),
        prixMinFocus:0,
        prixMaxFocus:0,
        surfaceMinFocus:0,
        surfaceMaxFocus:0,
        forms:{
          periode:{debut:'',fin:'',debut_dp:'',fin_dp:''},
          prestations:[],
          types_bien:[],
          prix:[0,2000000],
          surface:[10,1000],
          recherche:''
        },
        datas_def:{
          estimation_min:0,
          estimation_max:2000000,
          surface_min:10,
          surface_max:1000,
        },
        options_types_bien: [
            { id: "Appartement", text: this.$i18n.t("Appartement")},
            { id: "Maison", text: this.$i18n.t("Maison")},
        ],
        options_prestations_test: [
            { id: "EVAL", text: this.$i18n.t("Evaluations Ooftop")},
            { id: "EXETR", text: this.$i18n.t("Evaluations Ooftop avec analyse")},
            { id: "AVAL", text: this.$i18n.t("Avis de valeur")},
            { id: "EXIM", text: this.$i18n.t("Expertise immobilière")},
            { id: "DOCL", text: this.$i18n.t("Documents légaux")}
        ],
        options_prestations:[

        ],
        options:[],
        map:'',
        maplg:'',
        fiche:[],
        mapList:[],
        showFilter:false,
        exportProgress:false,
      }
    },
    mounted () {
      this.refresh();
      this.get_infos_cli();
      var p=this;
      for(let presta in this.options_prestations_test){
        if(this.infos_cli.menu.filter(p=>(p.id=='menu_'+this.options_prestations_test[presta]['id'])).length){
          this.options_prestations_test[presta]['text']=this.$i18n.t(this.infos_cli.menu.filter(p=>(p.id=='menu_'+this.options_prestations_test[presta]['id']))[0].title)
          this.options_prestations.push(this.options_prestations_test[presta]);
        }
      }

      axios.get(p.$apiUrl+"params/getFiltersParams",{params : {auth:p.auth_header()}}).then(response => {
        if(response.data.error=='notlogged'){
          p.logout();
          p.$router.push({ path: '/' });
        }
        else{
          p.options.gestionnaires=response.data.gestionnaires;
          p.options.services=response.data.services;
          p.options.organisations=response.data.organisations;
          p.datas_def=response.data.datas_def;
          p.forms.prix=[p.datas_def.estimation_min,p.datas_def.estimation_max];
          p.forms.surface=[p.datas_def.surface_min,p.datas_def.surface_max];
          var sliderPrix = document.getElementById('prix');
          if (sliderPrix && !sliderPrix.noUiSlider) {
            noUiSlider.create(sliderPrix, {start: p.forms.prix,connect:true,range: {'min': p.datas_def.estimation_min,'max': p.datas_def.estimation_max}});
            sliderPrix.noUiSlider.on('update', function (values) {
                p.forms.prix=values;
            });
          }
          var sliderSurface = document.getElementById('surface');
          if (sliderSurface && !sliderSurface.noUiSlider) {
            noUiSlider.create(sliderSurface, {start: p.forms.surface,connect:true,range: {'min': p.datas_def.surface_min,'max': p.datas_def.surface_max}});
            sliderSurface.noUiSlider.on('update', function (values) {
                p.forms.surface=values;
            });
          }
        }
      });
    },
    methods:{
      onContextDate(type) {
        if(this.$i18n.locale=="fr" && type){
          if(type=="fin" && this.forms.periode.fin_dp)this.forms.periode.fin=this.forms.periode.fin_dp.split('-').reverse().join('/');
          if(type=="debut" && this.forms.periode.debut_dp)this.forms.periode.debut=this.forms.periode.debut_dp.split('-').reverse().join('/');
        }
      },
      refresh(){
        if(this.filtre=='carte')this.show_map();
        else this.show_fiche();
      },
      filter_data(filtre){
        this.filtre=filtre;
        this.refresh();
      },
      reset_data(){
        this.forms={
          prestations:[],
          types_bien:[],
          surface:[this.datas_def.surface_min,this.datas_def.surface_max],
          prix:[this.datas_def.estimation_min,this.datas_def.estimation_max],
          periode:{
            debut:'',
            fin:'',
            debut_dp:'',
            fin_dp:'',
          },
          recherche:'',
        };
        this.reset_nui();
        this.refresh();
      },
      reset_nui(){
        var p=this;
        var sliderPrix = document.getElementById('prix');
        if (sliderPrix) {
          if (sliderPrix.noUiSlider) sliderPrix.noUiSlider.destroy();
          noUiSlider.create(sliderPrix, {start: p.forms.prix,connect:true,range: {'min': p.datas_def.estimation_min,'max': p.datas_def.estimation_max}});
          sliderPrix.noUiSlider.on('update', function (values) {
            p.forms.prix=values;
          })
        }
        var sliderSurface = document.getElementById('surface');
        if (sliderSurface) {
          if (sliderSurface.noUiSlider) sliderSurface.noUiSlider.destroy();
          noUiSlider.create(sliderSurface, {start: p.forms.surface,connect:true,range: {'min': p.datas_def.surface_min,'max': p.datas_def.surface_max}});
          sliderSurface.noUiSlider.on('update', function (values) {
            p.forms.surface=values;
          });
        }
      },
      exportD(){
        var p=this;
        p.exportProgress=true;
        p.forms.export=true;
        if(p.forms.periode.debut.length!=10)p.forms.periode.debut="";
        if(p.forms.periode.fin.length!=10)p.forms.periode.fin="";
        axios.get(p.$apiUrl+"demandes/liste/all/" ,{params : {auth:p.auth_header(),recherche:p.forms.recherche,filters:p.forms,limit:10000,startLine:0}}).then(response => {
          if(response.data.error=='notlogged'){
            p.logout();
            p.$router.push({ path: '/' });
          }
          p.exportProgress=false;
          if (response.data.excel){    
            window.open(this.$apiUrl+"demandes/exportExcel/"+response.data.excel+"?auth="+JSON.stringify(this.auth_header()));
          }
        }).catch(error => {});
      },
      show_map() {
        document.getElementById('mapContainer').innerHTML = "<div id='map' class='map'></div>";  
        this.map=L.map('map').setView([51.505, -0.09],6);
        var map = this.map;
        L.tileLayer('https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png', {attribution: '&copy; <a href="/">Ooftop Demo</a>'}).addTo(map);
        var markers = L.markerClusterGroup();
        var markersRef = {};
        var p=this;
        p.maplg = L.layerGroup().addTo(map);
        p.loading=true;
        let formData = new FormData();
        p.forms.export=false;
        formData.append('datas', JSON.stringify(p.forms));
        axios.post(p.$apiUrl+"demandes/carte?lang="+p.$i18n.locale+"&auth="+JSON.stringify(p.auth_header()),formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(function(response){
        p.loading=false;
          if(response.data.error=='notlogged'){
            p.logout();
            p.$router.push({ path: '/' });
          }
          if (response.data.datas && response.data.count>0) {
            p.mapList=response.data.datas;
            let countMarker=0;
            for(let iitem in p.mapList){
              let item=p.mapList[iitem];
              countMarker++;
              let  icon = L.divIcon({
                className: "my-custom-pin",
                iconAnchor: [0, 24],
                labelAnchor: [-6, 0],
                popupAnchor: [0, -36],
                html: '<span class="customMarker" id="marker_'+item.id+'" data-lat="'+item.lat+'" data-lng="'+item.lng+'" data-path="'+('/'+item.pf+'/detail/'+item.id)+'"><i>#'+countMarker+'</i></span>'
              })
              let marker=L.marker([item.lat,item.lng],{icon:icon});
              markersRef[item.id] = marker;
              markers.addLayer(marker);
            };
            var $ = window.jQuery = require('jquery') ;
            window.setTimeout(function(){
              $(".carte .row > .col-3 > ul > li").hover(function(){
                $(".customMarker").removeClass("active");
                let hm=$(this);
                let cmid=hm.data('id');
                let cm=$(".customMarker#marker_"+cmid);
                if(cm)cm.addClass("active");
                map.flyTo([hm.data('lat'),hm.data('lng')], 16)
              })
              $(".carte .row > .col-3 > ul > li,.customMarker").click(function(){      
                p.$router.push({ path: $(this).data('path') });
              })
            })
            map.addLayer(markers);
            map.fitBounds(markers.getBounds());
          } else {
            p.mapList=[];
          }
        }).catch(error => {});
      },
      show_fiche () {
        var p=this;
        p.fiche.graphs=[];
        if(p.forms.periode.debut.length!=10)p.forms.periode.debut="";
        if(p.forms.periode.fin.length!=10)p.forms.periode.fin="";
        p.loading=true;
        axios.get(this.$apiUrl+"demandes/graph?lang="+p.$i18n.locale,{params : {auth:this.auth_header(),recherche:p.forms.recherche,filters:p.forms}}).then(response => {
          p.loading=false;
          if(response.data.error=='notlogged'){
            p.logout();
            p.$router.push({ path: '/' });
          }
          if (response.data.datas) {
            p.fiche = response.data.datas;
          } else {
              //this.show_alert("warning","Pas de données disponible");
          }
        }).catch(error => {});
      },
      isNumber (evt){
          const keysAllowed = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.'];
          const keyPressed = evt.key;
          if(keyPressed=='Enter'){
            this.prixMinFocus=0;
            this.prixMaxFocus=0;
            this.surfaceMinFocus=0;
            this.surfaceMaxFocus=0;
            this.reset_nui();
          }
          if (!keysAllowed.includes(keyPressed)) {
              evt.preventDefault()
          }
      }
    }
  };
</script>
